<template>
  <chart-container :title="title" :containerClasses="{ 'pa-0': true }">
    <template v-slot:controls>
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="enableClustering = !enableClustering"
            v-bind="attrs"
            v-on="on"
            class="text-capitalize mb-1"
            width="20"
            height="20"
            outlined
            icon
          >
            <v-icon size="14" v-if="enableClustering">room</v-icon>
            <v-icon size="14" v-else>mdi-circle-double</v-icon>
          </v-btn>
        </template>
        <span v-if="enableClustering">Desagrupar</span>
        <span v-else>Agrupar</span>
      </v-tooltip>
    </template>
    <gmap-map
      v-if="enableClustering"
      ref="mapRef"
      :center="center"
      :options="gmapsOptions"
      map-type-id="terrain"
      v-bind:style="{
        height: computedOptions.height,
        border: '1px solid #999',
      }"
    >
      <gmap-cluster :enableRetinaIcons="true" :zoomOnClick="true">
        <gmap-info-window
          :options="infoOptions"
          :position="infoWindowPos"
          :opened="infoWinOpen"
          @closeclick="infoWinOpen = false"
        ></gmap-info-window>
        <gmap-marker
          v-for="(p, index) in computedPoints"
          :key="index"
          :position="p.position"
          :clickable="true"
          :draggable="false"
          @click="
            centerMap(p.position);
            toggleInfoWindow(p, index);
          "
        />
      </gmap-cluster>
    </gmap-map>
    <gmap-map
      v-else
      ref="mapRef"
      :center="center"
      :options="gmapsOptions"
      map-type-id="terrain"
      v-bind:style="{
        height: computedOptions.height,
        border: '1px solid #999',
      }"
    >
      <gmap-info-window
        :options="infoOptions"
        :position="infoWindowPos"
        :opened="infoWinOpen"
        @closeclick="infoWinOpen = false"
        color="red"
        background-opacity="0.5"
      ></gmap-info-window>
      <gmap-marker
        v-for="(p, index) in computedPoints"
        :key="index"
        :position="p.position"
        :clickable="true"
        :draggable="false"
        :animation="5"
        @click="
          centerMap(p.position);
          toggleInfoWindow(p, index);
        "
      />
    </gmap-map>
  </chart-container>
</template>

<script>
/*
  global google
*/
import _merge from "lodash.merge";
import _template from "lodash.template";

import ChartContainer from "@/components/dashboard/ChartContainer.vue";
import { GmapsOptions } from "@/commons/chart-commons.js";

const toolTipTemplateSource = `
    <div style="max-height:200px; max-width:300px; padding:5px 10px 0px 0;" >
      <div class="row no-gutters" style="display:flex; justify-content: space-between; padding-bottom:6px;">
          <% if (title) { %>
          <h4 class="text-justify"><a href="<%=url%>" target="_blank" ><%= title %></a></h4>
          <% } else { %>
          <div></div>
          <% } %>
          <div style="font-weight: 300; font-size:10;"><%= creationTime %></div>
      </div>
      <div class="row no-gutters">
          <% if (content) { %>
              <div class="col-12">
                  <p style="text-align: justify; margin: 0; padding-bottom: 5px;">
                    <%= content[0].length > 180 ? content[0].substring(0,180)+"...": content[0] %>
                  </p>
              </div>
          <% } %>
      </div>
      <div class="row no-gutters" style="display:flex; justify-content: space-between; padding-bottom:8px;">
          <div class="text-capitalize">
              <% if (!source.startsWith('file')) { %>
                  <% if (source.toLowerCase()=='twitter') { %>
                      <i class="fa fa-twitter"></i>
                  <% } else if (source.toLowerCase()=='facebook') { %>
                      <i class="fa fa-facebook-official"></i>
                  <% } else { %>
                      <i class="fa fa-rss"></i>
                  <% } %>
                  <%= source %>
              <% } %>
          </div>
          <% if (url && !url.toLowerCase().startsWith('file')) { %>
          <div>
              <a href="<%= url %>" target="_blank">
                  <i aria-hidden="true" class="v-icon notranslate mdi mdi-open-in-new " style="font-size:12px;"></i>
              </a>
          </div>
          <% } %>
      </div>
    </div>
`;
const toolTipTemplate = _template(toolTipTemplateSource);

export default {
  data() {
    return {
      enableClustering: true,
      center: GmapsOptions.defaultLocation,
      gmapsOptions: GmapsOptions.mapOptions,
      infoWindowPos: null,
      infoWinOpen: false,
      infoOptions: {
        content: "",
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      mapBounds: null,
    };
  },
  components: {
    ChartContainer,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    height: {
      type: Number,
      required: false,
    },
  },
  mounted() {
    console.log("mounted");
    this.$refs.mapRef.$mapPromise.then((mapRef) => {
      console.log("mapInit", mapRef);
      this.adjustMap();
    });
  },
  methods: {
     adjustMap() {
      const googlePoints = this.computedPoints.map(
        (point) =>
          new google.maps.LatLng(point.position.lat, point.position.lng)
      );
      const bounds = new google.maps.LatLngBounds();
      googlePoints.forEach((gp) => {
        bounds.extend(gp);
      });
      this.$refs.mapRef.fitBounds(bounds);
      this.$refs.mapRef.panToBounds(bounds);
    },
    toggleInfoWindow: function (marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoOptions.content = marker.infoText;
      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    centerMap({ lat, lng }) {
      console.log("centerMap", lat, lng);
      let bounds = new google.maps.LatLngBounds();
      bounds.extend(new google.maps.LatLng(lat, lng));
      this.$refs.mapRef.panToBounds(bounds);
    },
  },
  computed: {
    computedOptions() {
      const localOptions = {
        height: this.computedHeigth + "px",
      };
      return _merge({}, localOptions);
    },
    computedPoints() {
      return this.options.points.map((point) => {
        return {
          position: point.position,
          infoText: toolTipTemplate(point),
        };
      });
    },
    computedHeigth() {
      switch (this.height) {
        case 185:
          return 217;
        case 200:
          return 232;
        case 300:
          return 315.5;
        case 340:
          return 372;
        default:
          return (this.height + 6 || GmapsOptions.height) * 1.03;
      }
    },
  },
  watch: {
    computedPoints() {
      this.adjustMap();
    },
  },
};
</script>

<style>
.gm-style .gm-style-iw-c {
  background-color: rgba(255, 255, 255, 0.9) !important;
}

.gm-style-iw-d {
  overflow-y: hidden !important;
  overflow-x: hidden !important;
}
</style>
